<template>
	<div class="load-configuration"></div>
</template>

<script>
import * as R from 'ramda';
import LoadUnitConfigurationMixin from '@/mixins/load-unit-configuration';

export default {
	name: 'LoadConfiguration',
	mixins: [LoadUnitConfigurationMixin],
	methods: {
		async load(unitConfigurationId) {
			await this.loadUnitConfiguration(unitConfigurationId);
			const role = R.path(['query', 'role'], this.$route);
			const query = role ? {unitConfigurationId, role} : {unitConfigurationId};
			this.$router.replace({name: 'model', query});
		},
	},
	mounted() {
		const unitConfigurationId = R.path(['params', 'unitConfigurationId'], this.$route);
		return this.load(unitConfigurationId);
	},
};
</script>
